import React from 'react';
import './ContactSection.css';

const ContactSection = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <h2 className="contact-title">CONTACT</h2>
        <div className="divider-left"></div>
        
        <div className="contact-grid">
          <div className="contact-item">
            <h3 className="contact-label">Location</h3>
            <p className="contact-value">Stuttgart, Germany</p>
          </div>

          <div className="contact-item">
            <h3 className="contact-label">Phone</h3>
            <a 
              href="tel:+4915223528325" 
              className="contact-link"
            >
              +49 1522 3528325
            </a>
          </div>

          <div className="contact-item">
            <h3 className="contact-label">Hours</h3>
            <p className="contact-value">By Appointment</p>
          </div>

          <div className="contact-item">
            <h3 className="contact-label">Instagram</h3>
            <a 
              href="https://instagram.com/thelodge0711" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-link"
            >
              @thelodge0711
            </a>
          </div>

          <div className="contact-item">
            <h3 className="contact-label">Website</h3>
            <p className="contact-value">thelodgestuttgart.de</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;